import { Label } from "@/components/ui/label";

export const inputCls = "bg-zinc-900 border-zinc-800 text-zinc-100 text-base sm:text-sm";
export const selectCls = "h-10 w-full rounded-md border border-zinc-800 bg-zinc-900 px-3 text-base sm:text-sm text-zinc-100";
export const btnPrimary = "bg-green-brand hover:bg-green-brandDark text-white font-bold uppercase";
export const btnGhost = "bg-zinc-900 border-zinc-800 text-zinc-200 hover:bg-zinc-800 hover:text-white";

const p2 = (n) => String(n).padStart(2, "0");
export const isoDate = (d) => `${d.getFullYear()}-${p2(d.getMonth() + 1)}-${p2(d.getDate())}`;
export const todayIso = () => isoDate(new Date());
export const monthStartIso = () => { const d = new Date(); return isoDate(new Date(d.getFullYear(), d.getMonth(), 1)); };
export const addDaysIso = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return isoDate(d); };
export const fmtDate = (s) => (s ? `${s.slice(8, 10)}/${s.slice(5, 7)}/${s.slice(0, 4)}` : "—");
export const num = (v) => { const n = Number(String(v ?? "").replace(",", ".")); return Number.isFinite(n) ? n : 0; };
export const qtyFmt = (n) => Number(n || 0).toLocaleString("pt-BR", { maximumFractionDigits: 3 });

export function PageHead({ icon: Icon, kicker, title, children }) {
  return (
    <div className="flex items-start justify-between gap-3 flex-wrap">
      <div>
        <div className="flex items-center gap-2 text-xs font-mono-caps text-zinc-500 uppercase"><Icon className="h-4 w-4" /> {kicker}</div>
        <h1 className="font-display text-3xl font-black uppercase text-zinc-100 mt-1">{title}</h1>
      </div>
      <div className="flex items-center gap-2 flex-wrap">{children}</div>
    </div>
  );
}

export function Stat({ label, value, tone = "zinc", testid }) {
  const color = { green: "text-green-neon", amber: "text-amber-brand", red: "text-red-300", zinc: "text-zinc-100" }[tone];
  return (
    <div data-testid={testid} className="rounded-2xl border border-card2-border bg-card2 p-4 min-w-0">
      <div className="text-[11px] font-mono-caps uppercase text-zinc-500">{label}</div>
      <div className={`font-display text-xl sm:text-2xl font-black mt-1 truncate ${color}`}>{value}</div>
    </div>
  );
}

export function Field({ label, children, className = "" }) {
  return (
    <div className={`min-w-0 ${className}`}>
      <Label className="text-xs font-mono-caps text-zinc-400">{label}</Label>
      <div className="mt-1">{children}</div>
    </div>
  );
}

export function RangePicker({ from, to, onChange, testid = "range" }) {
  return (
    <div className="flex items-center gap-2">
      <input data-testid={`${testid}-from`} type="date" value={from} onChange={(e) => onChange([e.target.value, to])} className={`${selectCls} w-auto min-w-0`} />
      <span className="text-zinc-500 text-xs">até</span>
      <input data-testid={`${testid}-to`} type="date" value={to} onChange={(e) => onChange([from, e.target.value])} className={`${selectCls} w-auto min-w-0`} />
    </div>
  );
}

export function Empty({ children }) {
  return <div className="rounded-xl border border-dashed border-zinc-800 p-8 text-center text-sm text-zinc-500">{children}</div>;
}
